class FacetFilters extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-facets-toggle]');
    this.panel = this.querySelector('[data-facets-panel]');
    this.backdrop = this.querySelector('[data-facets-backdrop]');
    this.closeButton = this.querySelector('[data-facets-close]');
    this.form = this.querySelector('#FacetsForm');

    if (!this.panel) return;

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.openPanel());
    }
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closePanel());
    }
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.closePanel());
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.panel.classList.contains('is-open')) {
        this.closePanel();
      }
    });

    if (this.form) {
      this.form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.addEventListener('change', () => this.form.submit());
      });
    }
  }

  openPanel() {
    this.panel.classList.add('is-open');
    if (this.backdrop) this.backdrop.classList.add('is-open');
    document.documentElement.classList.add('facets-open');
    if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
  }

  closePanel() {
    this.panel.classList.remove('is-open');
    if (this.backdrop) this.backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('facets-open');
    if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('facet-filters', FacetFilters);

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-quick-add]');
  if (!button || button.disabled) return;
  event.preventDefault();

  const defaultLabel = button.dataset.labelDefault || button.textContent;
  button.disabled = true;
  button.textContent = button.dataset.labelAdding || defaultLabel;

  const formData = new FormData();
  formData.append('id', button.dataset.variantId);
  formData.append('quantity', 1);

  fetch(button.dataset.addUrl, {
    method: 'POST',
    body: formData,
    headers: { Accept: 'application/json' },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        button.textContent = defaultLabel;
        button.disabled = false;
        return;
      }
      button.textContent = button.dataset.labelAdded || defaultLabel;
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(() => {
        button.textContent = defaultLabel;
        button.disabled = false;
      }, 1500);
    })
    .catch(() => {
      button.textContent = defaultLabel;
      button.disabled = false;
    });
});
